import React from "react";
import Slide from "../../utils/images/accomodation-1920.jpg";
import styled from "styled-components";
import { HeartFilled, HomeFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

const Layout = styled.div`
  font-family: "Oswald" sans-serif;
  .desc {
    color: #fff;
    font-size: 15px;
    max-width: 810px;
    text-align: center;
    font-family: "Arvo", serif;
    font-size: 15px;
    line-height: 26px;
    margin: 25px;
    font-weight: 800;
    @media (max-width: 767px) {
      width: 100%;
      font-size: 180%;
    }
  }
  .title {
    color: #fff;
    margin-top: 30px;
    margin: 20px;
    font-size: 40px;
  }
  .circle {
    background-color: #fff;
    color: #6a6a6a;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 40px;
    display: grid;
    place-items: center;
    margin-top: -50px;
    /* margin-bottom: 37px; */
  }
  .icon-wrap {
    display: flex;
    justify-content: center;
    background: #f6f6f6;
    padding-bottom: 35px;
  }
`;

function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <h3 className="title">ACCOMODATION</h3>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>

          <p className="desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            ultrices malesuada ante quis pharetra. Nullam non bibendum dolor. Ut
            vel turpis accumsan, efficitur dolor fermentum, tincidunt metus.
          </p>
        </div>
        <div className="icon-wrap">
          <span className="circle">
            <HomeFilled />
          </span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(125,50,210,0.5),rgba(200,170,110,0.5)),url(${Slide})`,
    height: 470,
    backgroundSize: "cover",
    padding: 2,
    backgroundPosition: "center",
    objectFit: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
};

export default Banner;
